import type { BillingPeriod } from './constants';
import type { PlanType } from '@simplywallst/services';

export const isPaidPlan = (planType: PlanType): boolean => {
  return ['premium', 'unlimited'].includes(planType);
};

export const getCurrencySymbol = (currencyISO: string): string => {
  switch (currencyISO) {
    case 'EUR':
      return '€';
    case 'GBP':
      return '£';
    default:
      return '$';
  }
};

export const getDiscountedPlanAmount = (
  planAmount: number,
  percentOff: number
) => {
  return planAmount * (1 - percentOff);
};

export const formatMonthlyPrice = (
  amount: number,
  billingPeriod: BillingPeriod,
  currencyISO: string,
  locale = 'en'
): string => {
  const monthlyPrice = amount / (billingPeriod === 'year' ? 12 : 1);
  const currencySymbol = getCurrencySymbol(currencyISO);
  return `${currencySymbol}${monthlyPrice.toLocaleString(locale, {
    style: 'decimal',
    minimumFractionDigits: monthlyPrice % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatYearlyPrice = (
  amount: number,
  currencyISO: string,
  locale = 'en'
): string => {
  const currencySymbol = getCurrencySymbol(currencyISO);
  return `${currencySymbol}${amount.toLocaleString(locale, {
    style: 'decimal',
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};

export const getYearlyPriceDiscounted = (
  planAmount: number,
  planType: PlanType,
  couponPercentOff: number,
  isGrandfatherCoupon: boolean
) => {
  const discountedPlanAmount = getDiscountedPlanAmount(
    planAmount,
    couponPercentOff
  );

  const yearlyPrice =
    (isGrandfatherCoupon && planType === 'unlimited') || !isGrandfatherCoupon
      ? discountedPlanAmount
      : planAmount;

  return yearlyPrice;
};

export const formatTotalPrice = (
  amount: number,
  currencyISO: string,
  locale = 'en'
): string => {
  const currencySymbol = getCurrencySymbol(currencyISO);
  return `${currencySymbol}${amount.toLocaleString(locale, {
    style: 'decimal',
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};
